export default __webpack_public_path__ + "static/media/graph-heading.545b5566.png";